import React, { Ref } from 'react';

import { InputTekst, InputType } from '../../components/input/input-text';
import { Valideringstype } from '../../types/generated-types';
import { FocusableHtmlElement } from '../hooks';
import { isCurrentSporsmalValid } from '../reducer/current-steg';
import { updateSvar } from '../reducer/sporsmalsflyt-actions';
import { useSporsmalsflytDispatch } from '../reducer/sporsmalsflytDispatchProvider';
import { getFeilmeldingFrom } from '../reducer/valideringstype';
import { CurrentTekstsporsmal } from './tekst-types';

interface Props {
    currentSporsmal: CurrentTekstsporsmal;
    showFeilmelding: boolean;
    focusOnMount: boolean;
    errorRef?: Ref<FocusableHtmlElement>;
}

export const Tekst = ({ currentSporsmal, showFeilmelding, focusOnMount, errorRef }: Props) => {
    const dispatch = useSporsmalsflytDispatch();

    const onChange = (value: string) => {
        dispatch(updateSvar(value));
    };

    const inputType = (): InputType => {
        switch (currentSporsmal.sporsmal.valideringstype) {
            case Valideringstype.Epost:
                return InputType.Email;

            case Valideringstype.Mobilnummer:
            case Valideringstype.ValgfrittMobilnummer:
            case Valideringstype.ValgfrittTelefonnummer:
                return InputType.Telephone;

            case Valideringstype.Kontonummer:
            case Valideringstype.Fodselsnummer:
            case Valideringstype.Postnummer:
                return InputType.Number;

            default:
                return InputType.Text;
        }
    };

    return (
        <div className="container__standard-width">
            <InputTekst
                tittel={currentSporsmal.sporsmal.tekst}
                ingress={currentSporsmal.sporsmal.ingress}
                placeholder={currentSporsmal.sporsmal.placeholderText}
                verdi={currentSporsmal.svarTekst}
                onChange={onChange}
                feilmelding={getFeilmeldingFrom(
                    currentSporsmal.sporsmal.valideringstype,
                    currentSporsmal.svarTekst,
                    currentSporsmal.sporsmal.size,
                    currentSporsmal.sporsmal.maxNumberOfCharacters,
                )}
                isValid={!showFeilmelding || isCurrentSporsmalValid(currentSporsmal)}
                size={currentSporsmal.sporsmal.size}
                focusOnMount={focusOnMount}
                type={inputType()}
                errorRef={errorRef}
                id={`text-sporsmal-${currentSporsmal.sporsmal.id}`}
                key={`text-sporsmal-${currentSporsmal.sporsmal.id}`}
            />
        </div>
    );
};
